import { Component, OnInit, AfterViewInit } from "@angular/core";
import { ReportService } from "../report.service";
import { SchoolService } from "../../../shared/services/school.service";
//Import Custom Services Here
import { GradeLevelService } from "../report-services/grade-level.service";
import { HomeroomService } from "../report-services/homeroom.service";
import { GroupService } from "../report-services/group.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { DialogService } from "primeng/dynamicdialog";
import * as moment from "moment";

@Component({
	templateUrl: "./detentionsummary.component.html",
})
export class DetentionSummaryComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		private schoolService: SchoolService,
		//Insert Custom Services Here
		private groupService: GroupService,
		private homeroomService: HomeroomService,
		private gradelevelService: GradeLevelService,
		private dialogService: DialogService
	) {}
	report = {
		SchoolID: 0,
		//Insert Custom Parameters Here
		InfractionTypeID: "All",
		GradeLevelID: 0,
		HomeroomID: 0,
		GroupID: 0,
		StartDate: new Date(),
		EndDate: new Date(),
		OrderByID: "Date",
		ImageLogo: 0,
	};
	//Insert Custom Lists Here
	GradeLevelList: any = [];
	homeroomList: any = [];
	groupList: any = [];
	ImageLogoList: any = [];
	schoolList: any = [];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	InfractionTypeList = [
		//Insert Custom List Items Here
		{
			InfractionTypeID: "All",
			InfractionTypeName: "All",
		},
		{
			InfractionTypeID: "Unexcused Tardy",
			InfractionTypeName: "Unexcused Tardy",
		},
		{
			InfractionTypeID: "Detention Not Served",
			InfractionTypeName: "Detention Not Served",
		},
		{
			InfractionTypeID: "No Detention Scan",
			InfractionTypeName: "No Detention Scan",
		},
	];

	OrderByList = [
		//Insert Custom List Items Here
		{
			OrderByID: "Date",
			OrderByName: "Date",
		},
		{
			OrderByID: "Grade",
			OrderByName: "Grade",
		},
		{
			OrderByID: "Group",
			OrderByName: "Group",
		},
		{
			OrderByID: "HomeRoom",
			OrderByName: "HomeRoom",
		},
		{
			OrderByID: "Name",
			OrderByName: "Name",
		},
	];

	ReportID: number = 388;
	subscription: any;

	ngOnInit() {
		//Insert Custom Init Methods Here
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
		// this.loadSchoolist()
		// this.loadGradeLevelList()
		// this.loadHomeroomList()
		// this.loadGroupList()
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadGradeLevelList();
		this.loadHomeroomList();
		this.loadGroupList();
		this.loadLogolist();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(388);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.report.SchoolID = this.schoolList[0].SchoolID;
					this.loadGradeLevelList();
					this.loadHomeroomList();
					this.loadGroupList();
				}
			},
			(error) => {}
		);
	}

	private loadGradeLevelList() {
		this.report.GradeLevelID = 0;
		var result = this.gradelevelService.loadGradeLevelList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.GradeLevelList = response;

				this.report.GradeLevelID = this.GradeLevelList[0].GradeLevelID;
			},
			(error) => {}
		);
	}

	private loadHomeroomList() {
		this.report.HomeroomID = 0;
		var result = this.homeroomService.loadHomeroomList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.homeroomList = response;

				if (this.homeroomList.length > 1) {
					// this.homeroomList.unshift({
					//     HomeroomId: 0,
					//     HomeRoom: "All Homerooms"
					// })
				} else {
					this.report.HomeroomID = this.homeroomList[0].HomeroomId;
				}
			},
			(error) => {}
		);
	}

	private loadGroupList() {
		this.report.GroupID = 0;

		var result = this.reportService.GroupGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.groupList = response;

				if (this.groupList.length > 1) {
					this.groupList.unshift({
						GroupID: 0,
						GroupName: "All Groups",
					});
				} else if (this.groupList.length == 1) {
					this.report.GroupID = this.groupList[0].GroupID;
				} else {
					this.groupList.push({
						GroupID: 0,
						GroupName: "No Record found",
					});
				}
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		// if (!this.report.InfractionTypeID) {
		// 	this.errorMessage = "Select the InfractionType"
		// 	return;
		// }

		// if (!this.report.GradeLevelID) {
		// 	this.errorMessage = "Select the GradeLevel"
		// 	return;
		// }

		// if (!this.report.HomeroomID) {
		// 	this.errorMessage = "Select the Homeroom"
		// 	return;
		// }

		// if (!this.report.GroupID) {
		// 	this.errorMessage = "Select the Group"
		// 	return;
		// }

		// if (!this.report.StartDate) {
		// 	this.errorMessage = "Select the StartDate"
		// 	return;
		// }

		// if (!this.report.EndDate) {
		// 	this.errorMessage = "Select the EndDate"
		// 	return;
		// }

		// if (!this.report.OrderByID) {
		// 	this.errorMessage = "Select the OrderBy"
		// 	return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 388;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: InfractionType
		strParam += this.report.InfractionTypeID + "|InfractionType";

		//Parameter 2: GradeLevelID
		strParam += "," + this.report.GradeLevelID + "|GradeLevelID";

		//Parameter 3: HomeroomID
		strParam += "," + this.report.HomeroomID + "|HomeroomID";

		//Parameter 4: GroupID
		strParam += "," + this.report.GroupID + "|GroupID";

		//Parameter 5: StartDate
		strParam += "," + moment(this.report.StartDate).format("MM/DD/YYYY") + "|StartDate";

		//Parameter 6: EndDate
		strParam += "," + moment(this.report.EndDate).format("MM/DD/YYYY") + "|EndDate";

		//Parameter 7: OrderBy
		strParam += "," + this.report.OrderByID + "|OrderBy";

		//Parameter 8: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
